import { configureStore } from '@reduxjs/toolkit';
import accountsReducer from 'slices/accounts';
import authReducer from 'slices/auth';
import channelsReducer from 'slices/channels';
import chatsReducer from 'slices/chats';
import externalAppsReducer from 'slices/externalApps';
import externalAppWindowsReducer from 'slices/externalAppWindows';
import keyboardReducer from 'slices/keyboard';
import reauthReducer from 'slices/reauth';

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Thunks receive the bound API object as their argument ([API, params]), which RTK stores
      // in meta.arg. Everything else (payloads, state) must stay serializable.
      serializableCheck: { ignoredActionPaths: ['meta.arg'] },
    }),
  reducer: {
    accounts: accountsReducer,
    auth: authReducer,
    chats: chatsReducer,
    channels: channelsReducer,
    externalApps: externalAppsReducer,
    externalAppWindows: externalAppWindowsReducer,
    keyboard: keyboardReducer,
    reauth: reauthReducer,
  },
});
